/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function HighInterpretationIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 9 9" className={props.className}>
      <path
        d="M4.49997 -3.93405e-07C4.64655 -3.80591e-07 4.79248 0.0550038 4.91141 0.165726L8.76863 3.73741C9.0412 3.98957 9.07849 4.44032 8.85091 4.7432C8.62398 5.04608 8.21897 5.0868 7.94575 4.83463L4.4929 1.63726L1.04584 4.71963C0.769404 4.96679 0.364397 4.91821 0.141964 4.61105C-0.0804681 4.30388 -0.0367536 3.85456 0.23968 3.60669L4.0969 0.157868C4.21454 0.0528608 4.35726 -4.05881e-07 4.49997 -3.93405e-07Z"
        fill="#F62121"
      />
      <path
        d="M4.49997 4C4.64655 4 4.79248 4.055 4.91141 4.16573L8.76863 7.73741C9.0412 7.98957 9.07849 8.44032 8.85091 8.7432C8.62398 9.04608 8.21897 9.0868 7.94575 8.83463L4.4929 5.63726L1.04584 8.71963C0.769404 8.96679 0.364397 8.91821 0.141964 8.61105C-0.0804681 8.30388 -0.0367536 7.85456 0.23968 7.60669L4.0969 4.15787C4.21454 4.05286 4.35726 4 4.49997 4Z"
        fill="#F62121"
      />
    </SvgIcon>
  );
}
